import ColumnFilterContainer from '@/components/ColumnFilters/ColumnFilterContainer';
import type { ColumnFilterValue } from '@/models/flowFilter.type';
import { DateInput } from '@mantine/dates';
import { useTranslate } from '@tolgee/react';

type DateRangeColumnFilterProps = {
  label: string;
  value: ColumnFilterValue | undefined;
  onChange: (value: ColumnFilterValue | undefined) => void;
};

/** Filtre sur une plage de jours (du début du premier jour à la fin du dernier, inclus). */
const DateRangeColumnFilter = ({ label, value, onChange }: DateRangeColumnFilterProps) => {
  const { t } = useTranslate();
  const from = value?.kind === 'date-range' ? value.from : undefined;
  const to = value?.kind === 'date-range' ? value.to : undefined;

  const update = (next: { from?: string; to?: string }) =>
    onChange(!next.from && !next.to ? undefined : { kind: 'date-range', ...next });

  return (
    <ColumnFilterContainer onReset={() => onChange(undefined)}>
      <DateInput
        clearable
        label={`${label} — ${t('common.filters.from')}`}
        value={from ?? null}
        onChange={date => update({ from: date ?? undefined, to })}
      />
      <DateInput
        clearable
        label={`${label} — ${t('common.filters.to')}`}
        value={to ?? null}
        onChange={date => update({ from, to: date ?? undefined })}
      />
    </ColumnFilterContainer>
  );
};

export default DateRangeColumnFilter;
